import { IconButton, IconButtonProps, styled } from '@mui/material';

export const InformationButton = styled((props: IconButtonProps) => (
  <IconButton size="small" color="primary" {...props} />
))(({ theme }) => ({
  padding: theme.spacing(0.5),
  '& > svg': {
    fontSize: '1rem',
  },
}));
